var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborateicon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.199,
    height: 102.252,
    viewBox: "0 0 102.199 102.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(-0.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2707",
    "data-name": "Group 2707",
    transform: "translate(0.126 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4429",
    "data-name": "Path 4429",
    d: "M97.215,224.978V161.955a1.7,1.7,0,0,0-1.7-1.7H78.478a1.7,1.7,0,0,0-1.7,1.7v63.022H73.368V185.8a1.7,1.7,0,0,0-1.7-1.7H54.632a1.7,1.7,0,0,0-1.7,1.7v39.176H49.522V168.769a1.7,1.7,0,0,0-1.7-1.7H30.786a1.7,1.7,0,0,0-1.7,1.7v56.209H25.676V192.615a1.7,1.7,0,0,0-1.7-1.7H6.939a1.7,1.7,0,0,0-1.7,1.7v32.363H.126v3.407h102.2v-3.407Zm-74.946,0H8.643v-30.66H22.269Zm23.846,0H32.489V170.472H46.115Zm23.846,0H56.335V187.5H69.962Zm23.846,0H80.182V163.659H93.808Z",
    transform: "translate(-0.126 -126.132)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4430",
    "data-name": "Path 4430",
    d: "M35.94,46.334a8.517,8.517,0,0,0,11.8-11.8L59.8,22.476A8.43,8.43,0,0,0,64.466,23.9a8.548,8.548,0,0,0,1.5-.131,8.456,8.456,0,0,0,4.323-2.16L80.39,29.378a8.517,8.517,0,1,0,15.044-1.659l12.053-12.053a8.542,8.542,0,1,0-2.408-2.408L93.026,25.31a8.516,8.516,0,0,0-10.717,1.082c-.032.032-.051.07-.082.1l-9.959-7.655a8.517,8.517,0,1,0-14.884,1.235L45.333,32.125A8.517,8.517,0,1,0,35.94,46.334ZM112.176,3.46a5.11,5.11,0,1,1-5.11,5.11A5.11,5.11,0,0,1,112.176,3.46ZM84.715,28.8a5.11,5.11,0,1,1,7.228,7.226,5.236,5.236,0,0,1-7.225,0A5.11,5.11,0,0,1,84.715,28.8ZM60.3,12.453h0a5.078,5.078,0,0,1,3.3-2.1,5.33,5.33,0,0,1,.9-.077,5.11,5.11,0,1,1-4.2,2.179ZM37.022,35.618l0,0a5.11,5.11,0,1,1,7.225,7.229,5.236,5.236,0,0,1-7.225,0A5.11,5.11,0,0,1,37.022,35.618Z",
    transform: "translate(-25.307 0)",
    fill: "#ed1c24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborateicon1);
export default __webpack_public_path__ + "static/media/collaborateicon1.15f07398aadd9c2959c0d281f71f6364.svg";
export { ForwardRef as ReactComponent };